<script lang="ts">
  import { WebsiteName } from "../../../config"
</script>

<svelte:head>
  <title>Privacy Policy - {WebsiteName}</title>
</svelte:head>

<div class="container mx-auto px-4 py-8">
  <div class="prose max-w-none">
    <h1>Privacy Policy</h1>
    <p class="text-muted-foreground">
      Last updated: {new Date().toLocaleDateString()}
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      We collect information you provide directly to us when using AceTheRound,
      including:
    </p>
    <ul>
      <li>Account information (name, email, etc.)</li>
      <li>Interview recordings and transcripts</li>
      <li>Usage data and analytics</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide and improve our services</li>
      <li>Analyze and enhance interview performance</li>
      <li>Communicate with you about our services</li>
      <li>Protect against fraudulent or illegal activity</li>
    </ul>

    <h2>3. Information Sharing</h2>
    <p>
      We do not sell your personal information. We may share your information
      only:
    </p>
    <ul>
      <li>With your consent</li>
      <li>To comply with legal obligations</li>
      <li>To protect our rights and safety</li>
    </ul>

    <h2>4. Data Security</h2>
    <p>
      We implement appropriate technical and organizational measures to protect
      your personal information.
    </p>

    <h2>5. Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Access your personal information</li>
      <li>Correct inaccurate data</li>
      <li>Request deletion of your data</li>
      <li>Opt-out of certain data processing</li>
    </ul>

    <h2>6. Changes to This Policy</h2>
    <p>
      We may update this privacy policy from time to time. We will notify you of
      any changes by posting the new policy on this page.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us.
    </p>
  </div>
</div>
